import styled from 'styled-components';

export const Container = styled.article`
  margin-top: 8rem;
  max-width: 1000px;
  margin: 4rem auto;
  padding: 120px 2rem;
  width: 100%;

  @media (max-width: 600px) {
    margin-top: 2rem;
  }
`;

export const Header = styled.header`
  text-align: center;
  padding: 6rem 0;

  h4 {
    font-weight: normal;
  }

  @media (max-width: 600px) {
    padding-top: 2rem;
  }
`;

export const Title = styled.h1`
  font-family: secondarytypeface, 'Georgia', serif;
  line-height: 1.3;
  color: var(--header-text-color);
  margin-bottom: 1rem;
  font-weight: 100;
  font-size: 5rem;

  @media (max-width: 600px) {
    font-size: 4rem;
  }
`;

export const ArticleBody = styled.div`
  /* white-space: pre-line; */

  a {
    color: var(--primary-500);
    text-decoration: underline;

    &:hover {
      color: var(--primary-600);
      text-decoration: none;
    }
  }

  p {
    line-height: 1.5;
    font-size: 18px;
    margin: 0 0 1em;
  }

  blockquote {
    margin-left: 0.25rem;
    font-size: 1.6rem;
    color: inherit;
    font-style: italic;
    border-left: 0.2rem solid rgb(0, 0, 0);
    padding-left: 1rem;
    margin: 1rem 0;
  }

  pre {
    margin-bottom: 2rem;
  }

  h3 {
    line-height: 1.13;
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 2rem 0 2rem;
  }

  li {
    line-height: 1.65;

    p {
      font-size: inherit;
      margin: 0;
      line-height: inherit;
    }
  }

  hr {
    border: 0;
    border-top: 0.1rem solid #ccc;
    display: block;
    height: 1rem;
    padding: 0;
  }
`;
